import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { OpkraevningGridComponent } from '@features/opkraevning/opkraevning-grid/opkraevning-grid.component';
import { OpkraevningService } from '@features/opkraevning/opkraevning.service';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Dialog } from 'primeng/dialog';
import { Panel } from 'primeng/panel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { GodkendAlleSummary } from '../godkendalle-summary.model';
import { OpkraevningsListerService } from '../opkraevningslister.service';

@Component({
  selector: 'app-opkraevningslister-detail',
  imports: [
    DatePipe,
    DecimalPipe,
    ConfirmDialog,
    Dialog,
    ScrollPanelModule,
    ReactiveFormsModule,
    ButtonModule,
    OpkraevningGridComponent,
    Panel,
  ],
  providers: [ConfirmationService],
  templateUrl: './opkraevningslister-detail.component.html',
  styleUrl: './opkraevningslister-detail.component.css',
})
export class OpkraevningsListerDetailComponent {
  confirmationService = inject(ConfirmationService);
  opkraevningService = inject(OpkraevningService);
  opkraevningsListerService = inject(OpkraevningsListerService);
  godkendAlleSummary = signal<GodkendAlleSummary | undefined>(undefined);
  showGodkendAlleSummary = signal(false);

  async onClickGodkendAlle() {
    const response =
      await this.opkraevningsListerService.datasource.godkendAlle(
        this.opkraevningsListerService.selectedOpkraevningsListe()!.id
      );
    this.opkraevningService.datasource.loadData();
    this.opkraevningsListerService.loadSummary();
    this.godkendAlleSummary.set(response);
    this.showGodkendAlleSummary.set(true);
  }

  onClickAfsend() {
    const summary = this.opkraevningsListerService.summary();
    if (!summary) return;

    const antalIkkeGodkendte =
      summary.antalOpkraevninger - summary.antalGodkendte;
    if (antalIkkeGodkendte > 0) {
      this.confirmationService.confirm({
        message: `Der er ${antalIkkeGodkendte} betalinger, der ikke er godkendt - fortsæt?`,
        header: 'Afsend opkrævninger',
        rejectButtonProps: {
          label: 'Fortryd',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Godkend',
        },

        accept: async () => {
          this.afsendKoersel();
        },
      });
    } else {
      this.afsendKoersel();
    }
  }

  async afsendKoersel() {
    await this.opkraevningsListerService.datasource.afsendKoersel(
      this.opkraevningsListerService.selectedOpkraevningsListe()!.id
    );
  }

  afsendt = computed(
    () => !!this.opkraevningsListerService.selectedOpkraevningsListe()?.afsendt
  );

  closeGodkendAlleSummary() {
    this.showGodkendAlleSummary.set(false);
  }

  onClickExport(opkraevningsListeId: number) {
    this.opkraevningsListerService.exportData(opkraevningsListeId);
  }
}
